import React, { Component } from 'react'
import styled from 'styled-components'
import Transition from 'react-transition-group/Transition'

import tabIpsumIcon from '../images/tab-ipsum-icon.svg'

const Container = styled.div`
  width: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 3;
  top: 0;
  left: 0;
  padding: 50px 4vw 50px 10vw;
  transition: opacity .6s ease, transform .6s ease;
  opacity: 0;
  transform: translateY(20px);
  @media(max-width: 680px) {
    position: relative;
    padding: 50px 10vw;
  }
`
const Icon = styled.img`
  width: 25px;
  height: auto;
`

const LogoType = styled.div`
  font-weight: 300;
  margin-left: 10px;
  font-size: 20px;
  margin-top: 3px;
  letter-spacing: -0.5px;
  opacity: 0.7;
  transition: opacity .3s ease;
`

const Logo = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #FFF;

  &:hover{

    ${LogoType} {
      opacity: 1;
    }
  }
`

const transitionStyles = {
  entered:  {
    opacity: 1,
    transform: 'translateY(0)'
  },
}


class Header extends Component {
  render () {
    return (
      <Transition in={this.props.loaded} timeout={300}>
        {(state) => (
          <Container style={{...transitionStyles[state]}}>
          <Logo href='/'>
            <Icon src={tabIpsumIcon} /> 
            <LogoType>tabipsum</LogoType>
          </Logo>
          <iframe title='Like' src="https://ghbtns.com/github-btn.html?user=edkf&repo=tabipsum&type=star&count=true" frameborder="0" scrolling="0" width="80px" height="20px"></iframe>
          </Container>
        )}
      </Transition>
    )
  }
}

export default Header


// WEBPACK FOOTER //
// ./src/components/Header.jsx